import axios from "@/shared/scripts/AutoRefreshAxios";
import store from "@/shared/store";

export interface GetPropertyByAddressResponse {
  property: any;
  transaction: any;
}

export function getPropertyByAddress(
    address: string,
    propertyType?: string
): Promise<GetPropertyByAddressResponse> {

    const baseUrl: string = process.env.VUE_APP_COMPLETION_URL || "";
    const version = "1";
    const endpoint = "completion";
    const urlend = "property-details";

    const params: Record<string, string> = {
        address: address
    };

    if (propertyType) {
        params.propertyType = propertyType;
    }

    return axios
        .get<GetPropertyByAddressResponse>(
            `${baseUrl}${endpoint}/${version}/${urlend}`,
            {
                params: params,
                headers: {
                    "Content-Type": "application/json",
                    "x-api-key": process.env.VUE_APP_COMPLETION_API_KEY,
                    Authorization: "Bearer " + store.getters["UserModule/getUser"].jwtToken,
                },
            }
        )
        .then(res => res.data)
        .catch((error) => {
            console.error("Error fetching property by address", error);
            throw error;
        });
}


